import { render, staticRenderFns } from "./GiftPromotionEdit.vue?vue&type=template&id=76e05259&scoped=true"
import script from "./GiftPromotionEdit.vue?vue&type=script&lang=js"
export * from "./GiftPromotionEdit.vue?vue&type=script&lang=js"
import style0 from "./GiftPromotionEdit.vue?vue&type=style&index=0&id=76e05259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e05259",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
